<template>
  <div class="collect-content">
    <div class="page-title">{{ $t('message.home.myCoupon') }}</div>

    <div class="tabs">
      <div v-for="tab in tabs" :key="tab.value" :class="['tab-item', { active: tabActive === tab.value }]"
        @click="tabChange(tab.value)">{{ tab.label }}</div>
    </div>

    <div v-loading="loading">
      <div class="coupon-list" v-if="list.length">
        <div class="coupon-card" v-for="item in list" :key="item.id"
          :class="{ used: item.useStatus === 1, expired: item.useStatus === 2 }">
          <div class="coupon-left">
            <div class="discount-amount">
              <span class="currency">¥</span>{{ item.couponPrice || item.discountAmount || '' }}
            </div>
            <div class="use-threshold" v-if="item.useThreshold">
              {{ $t('message.home.minSpend') }}: ¥{{ item.useThreshold }}
            </div>
          </div>
          <div class="coupon-right">
            <div class="coupon-name">{{ item.couponName || item.storeName }}</div>
            <div class="coupon-expire">{{ $t('message.home.expires') }}: {{ item.endDate || '—' }}</div>
            <div class="coupon-status">
              <el-tag size="mini" :type="['', 'info', 'danger'][item.useStatus]">
                {{ [$t('message.home.unused'), $t('message.home.used'), $t('message.home.expired')][item.useStatus] }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
    </div>
    <div class="common-pagination" v-if="total > 0">
      <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
        :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
    </div>
  </div>
</template>

<script>
import { listCoupon } from "@/api/marketing/coupon_code";

export default {
  name: "MyCoupon",
  data() {
    return {
      loading: false, list: [], total: 0, tabActive: 0,
      tabs: [
        { value: 0, label: this.$t('message.home.unused') },
        { value: 1, label: this.$t('message.home.used') },
        { value: 2, label: this.$t('message.home.expired') },
      ],
      queryParams: { pageNumber: 1, pageSize: 20, useStatus: 0 }
    }
  },
  created() { this.loadData() },
  methods: {
    /** 后端返回 CouponCode，优惠券详情在嵌套 coupon 对象中（与移动端一致） */
    normalizeCouponItem(item) {
      const c = item.coupon || {}
      let useStatus = 0
      if (item.isUsed) useStatus = 1
      else if (c.hasExpired) useStatus = 2
      return {
        ...item,
        couponName: c.name || item.couponName || '',
        endDate: c.endDate || item.endDate || '',
        couponPrice: c.priceExpression || item.couponPrice || '',
        discountAmount: c.priceExpression || item.discountAmount || '',
        useThreshold: c.minimumPrice ?? item.useThreshold,
        storeName: c.storeName || item.storeName || '',
        useStatus
      }
    },
    loadData() {
      this.loading = true
      listCoupon(this.queryParams).then(r => {
        const raw = r.data?.data?.content || r.data?.data || []
        const normalized = (Array.isArray(raw) ? raw : []).map(item => this.normalizeCouponItem(item))
        const filtered = normalized.filter(item => item.useStatus === this.tabActive)
        this.list = filtered
        this.total = filtered.length
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    tabChange(val) {
      this.tabActive = val
      this.queryParams.useStatus = val
      this.queryParams.pageNumber = 1
      this.loadData()
    },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() }
  }
}
</script>

<style lang="scss" scoped>
.collect-content { padding: 24px 34px; }
.page-title { font-size: 20px; font-weight: bold; color: #333; margin-bottom: 20px; }
.tabs { display: flex; gap: 10px; margin-bottom: 20px; }
.tab-item { padding: 6px 20px; border-radius: 20px; background: #f5f5f5; color: #666; cursor: pointer; font-size: 14px; }
.tab-item.active { background: #409eff; color: #fff; }
.coupon-list { display: flex; flex-direction: column; gap: 12px; }
.coupon-card { display: flex; border-radius: 8px; overflow: hidden; border: 1px solid #ffd700; background: linear-gradient(135deg, #fff8e1, #fff); }
.coupon-card.used, .coupon-card.expired { border-color: #eee; background: #f9f9f9; filter: grayscale(.6); }
.coupon-left { background: #ff6b35; color: #fff; padding: 20px 24px; min-width: 120px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.discount-amount { font-size: 28px; font-weight: bold; line-height: 1; }
.currency { font-size: 14px; }
.use-threshold { font-size: 12px; opacity: .85; margin-top: 4px; }
.coupon-right { flex: 1; padding: 16px 20px; }
.coupon-name { font-size: 15px; font-weight: bold; color: #303133; margin-bottom: 8px; }
.coupon-expire { font-size: 13px; color: #909399; margin-bottom: 8px; }
.common-pagination { margin-top: 20px; }
</style>
